/**
 * lib/recruitTracking — Phase F.4 recruiter-funnel event helper.
 *
 * Fire-and-forget POST to `/api/public/coverage-recruit-event` that
 * never throws and never blocks the FE on failure. Used to track
 * funnel stages (empty-state views, CTA clicks, waitlist submits).
 *
 * Privacy: this module sends ONLY {event_type, zip?, source?}. It
 * never reads or transmits email, IP, user-id, or session cookies.
 * The backend additionally validates `event_type` against a locked
 * allowlist (see backend/coverage.py:COVERAGE_RECRUIT_EVENT_TYPES).
 */
import { API_BASE } from "@/lib/api";

export async function trackRecruitEvent(eventType, opts = {}) {
  try {
    const body = { event_type: eventType };
    if (opts.zip) body.zip = String(opts.zip);
    if (opts.source) body.source = String(opts.source).slice(0, 32);
    // Use keepalive so the request survives page navigations triggered
    // by CTA clicks (a click that immediately scrolls / nav'd before
    // the fetch completed would otherwise drop the event).
    await fetch(`${API_BASE}/public/coverage-recruit-event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch {
    /* swallow — funnel tracking must never break a flow */
  }
}
